import Image from 'next/image'

import { FixedBottomDrawerButton } from '../../FixedBottomDrawerButton'

type Props = {
  goBack: () => void
}

export const InviteCreationFailedScreen = ({ goBack }: Props) => (
  <div className="flex flex-1 flex-col items-center justify-between px-40 pb-[120px] md:px-24 xxs:px-16">
    <div className="flex flex-1 flex-col items-center justify-center gap-20 pb-80">
      <Image
        src="/images/shared/Blocked.png"
        width={140}
        height={140}
        alt="blocked"
        className="rotate-12"
      />
      <p className="text-center text-grey-70 text-20 xxs:text-16">
        Этот номер телефона уже используется. Создайте новое приглашение, указав
        другой номер.
      </p>
    </div>
    <FixedBottomDrawerButton text="Понятно" onClick={goBack} />
  </div>
)
